import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import Title from 'evcharging/components/Title';
import Spacer from 'evcharging/components/Spacer';
import bg from 'evcharging/assets/ev-software/softwareApp.png';
import app from 'evcharging/assets/ev-software/app.png';
import DecorList from 'evcharging/containers/ev-software/DecorList';
import Baget from 'evcharging/components/Baget';
import appEv from 'evcharging/assets/ev-software/appEv.png';
import InlineGap from 'evcharging/components/InlineGap';
import Desktop from 'evcharging/components/Desktop';
import Mobile from 'evcharging/components/Mobile';
import SoftwareButton from 'evcharging/containers/layout/SoftwareButton';
import useI18n from 'evcharging/hooks/useI18n';
import Image from 'next/image';

const EvApp = () => {
  const { t } = useI18n();

  return (
    <Section
      backgroundSize={'cover'}
      backgroundColor={'#f6f8f9'}
      backgroundImage={`url(${bg})`}
      backgroundPosition={'center'}
      padding={'45px 0'}
    >
      <Container position={'relative'}>
        <Mobile>
          <Box maxWidth={495} margin={'0 auto'}>
            <Image src={app} alt={t('software.app.alt')} width={495} height={563} />
            <Spacer value={50} />
          </Box>
        </Mobile>
        <Desktop>
          <Box position={'absolute'} top={-97} right={0}>
            <Image
              src={app}
              alt={t('software.app.alt')}
              layout={'fixed'}
              width={495}
              height={563}
            />
          </Box>
        </Desktop>
        <Responsible fractions={[50, 50]}>
          <Box>
            <Box display={'flex'} alignItems={'center'}>
              <Image src={appEv} alt={t('software.app.alt')} width={53} height={53} />
              <InlineGap desktop={16} />
              <Baget>{t('software.app.label')}</Baget>
            </Box>
            <Spacer value={16} />
            <Title variant={'h2'}>{t('software.app.title')}</Title>
            <Spacer value={20} />
            <DecorList
              items={[
                t('software.app.item1'),
                t('software.app.item2'),
                t('software.app.item3'),
                t('software.app.item4'),
              ]}
            />
            <Spacer value={48} />
            <SoftwareButton showDesktop />
          </Box>
          <Desktop>
            <span />
          </Desktop>
        </Responsible>
      </Container>
    </Section>
  );
};

export default EvApp;
